var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1517",
    "data-name": "Rectangle 1517",
    width: 24,
    height: 24,
    transform: "translate(16376.5 1488)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sso",
    transform: "translate(-16376.5 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_176",
    "data-name": "Union 176",
    d: "M11.692,22c-.149-1.132.859-1.714,2-2V17h-5v3c1.141.285,2.149.868,2,2s-1.822,2-3,2a2.03,2.03,0,0,1-2-2c-.148-1.132.859-1.714,2-2V17h-5v3c1.141.285,2.148.868,2,2a2.03,2.03,0,0,1-2,2c-1.179,0-2.852-.868-3-2s.86-1.714,2-2V17a.91.91,0,0,1,1-1h5V14c-.864,0-.269,0,.4,0a7.263,7.263,0,0,1-7.4-7,7.271,7.271,0,0,1,7.5-7,7.271,7.271,0,0,1,7.5,7,7.263,7.263,0,0,1-7.4,7c.667,0,1.263,0,.4,0v2h5a.91.91,0,0,1,1,1v3c1.141.285,2.148.868,2,2s-1.822,2-3,2A2.03,2.03,0,0,1,11.692,22Zm1,0a.91.91,0,0,0,1,1c.646,0,2-.374,2-1s-1.354-1-2-1A.909.909,0,0,0,12.692,22Zm-6,0a.91.91,0,0,0,1,1c.646,0,2-.374,2-1s-1.354-1-2-1A.909.909,0,0,0,6.692,22Zm-6,0c0,.626,1.355,1,2,1a1,1,0,1,0,0-2C2.046,21,.691,21.374.691,22ZM6.3,5.09a.765.765,0,0,0,.776.752h.444V7.38a2.831,2.831,0,0,0-1.22.7,2.672,2.672,0,0,0,0,3.866,2.886,2.886,0,0,0,3.991,0,2.672,2.672,0,0,0,0-3.866,2.835,2.835,0,0,0-1.22-.7V2.225a.776.776,0,0,0-1.552,0V2.4H7.075a.751.751,0,1,0,0,1.5h.444v.441H7.075A.765.765,0,0,0,6.3,5.09Zm.725,4.919a1.271,1.271,0,1,1,1.271,1.23A1.253,1.253,0,0,1,7.024,10.009Z",
    transform: "translate(16379.809 1488)",
    fill: "#003fb9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSso);
export default __webpack_public_path__ + "static/media/ic_sso.4a9b3cc5e8735fbccb7c45377e83f870.svg";
export { ForwardRef as ReactComponent };